import { render, staticRenderFns } from "./schedule_home.vue?vue&type=template&id=3f2467c4&scoped=true"
import script from "./schedule_home.vue?vue&type=script&lang=js"
export * from "./schedule_home.vue?vue&type=script&lang=js"
import style0 from "./schedule_home.vue?vue&type=style&index=0&id=3f2467c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2467c4",
  null
  
)

export default component.exports